import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_MEMBER_LANG: {
  STUDY_MEMBER_INVITATION_TITLE: MvnCodeFE;
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_INVITER: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_STUDY: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_JOIN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_JOIN_NOUN: MvnCodeFE;
  STUDY_MEMBER_STATUS_INVITED: MvnCodeFE;
  STUDY_MEMBER_STATUS_REGISTERED: MvnCodeFE;
  STUDY_MEMBER_STATUS_LEFT: MvnCodeFE;
  MEMBERS_TAB: MvnCodeFE;
  ROLES_TAB: MvnCodeFE;

  MEMBER_NOUN: MvnCodeFE;
  ROLE_NOUN: MvnCodeFE;

  RESEND_VERB: MvnCodeFE;
  DELETE_VERB: MvnCodeFE;

  ADD_ROLE_VERB: MvnCodeFE;
  INVITE_VERB: MvnCodeFE;

  ROLE_DUPLICATE_DESCRIPTION: MvnCodeFE;

  CREATE_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  CREATE_MEMBER_ROLE_FAIL: MvnCodeFE;
  MODIFY_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  MODIFY_MEMBER_ROLE_FAIL: MvnCodeFE;

  STUDY_MEMBER_INVITATION_SUCCEED: MvnCodeFE;
  STUDY_MEMBER_INVITATION_FAIL: MvnCodeFE;

  STUDY_MEMBER_RESEND_EMAIL_SUCCEED: MvnCodeFE;
  STUDY_MEMBER_RESEND_EMAIL_FAIL: MvnCodeFE;

  DELETION_MEMBER_SUCCEED: MvnCodeFE;
  DELETION_MEMBER_FAIL: MvnCodeFE;
  DELETION_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  DELETION_MEMBER_ROLE_FAIL: MvnCodeFE;

  STUDY_ROLE_SWITCH_CONFIRM_TITLE: MvnCodeFE;
  STUDY_ROLE_SWITCH_CONFIRM_DESCRIPTION: MvnCodeFE;

  STUDY_MEMBER_ROLE_MODIFICATION_TITLE: MvnCodeFE;
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_INACTIVE_DESCRIPTION: MvnCodeFE;
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_DELETION_DESCRIPTION: MvnCodeFE;

  STUDY_MEMBER_TABLE_HEADER_NO: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_TYPE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_NAME: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_EMAIL: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_ROLE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_STATUS: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_LAST_SENT_EMAIL_DATE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_ACTIVATED_AT: MvnCodeFE;

  STUDY_MEMBER_INVITATION_DIALOG_TITLE: MvnCodeFE;
  STUDY_MEMBER_INVITATION_DIALOG_EMAIL_PLACEHOLDER: MvnCodeFE;
  STUDY_MEMBER_INVITATION_DIALOG_ROLE_PLACEHOLDER: MvnCodeFE;
} = {
  STUDY_MEMBER_INVITATION_TITLE: {
    ko: "[Maven Converter]에 초대되었습니다.",
    en: "You’ve been invited to [Maven Converter].",
  },
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: {
    ko: "스터디 이름",
    en: "Study Name",
  },
  STUDY_MEMBER_INVITATION_CONTENT_INVITER: {
    ko: "{inviter} ({inviterEmail}) 께서",
    en: "{inviter} ({inviterEmail}) has",
  },
  STUDY_MEMBER_INVITATION_CONTENT_STUDY: {
    ko: "귀하를 Maven Converter의 {studyName} 에 초대했습니다.",
    en: "invited you to join the {studyName} in Maven Converter.",
  },

  STUDY_MEMBER_INVITATION_CONTENT_JOIN: {
    ko: "Join 버튼을 클릭하여 초대받은 스터디를 확인할 수 있습니다.",
    en: "Press the 'Join' button to access the study.",
  },
  STUDY_MEMBER_INVITATION_JOIN_NOUN: {
    ko: "Join",
    en: "Join",
  },
  STUDY_MEMBER_STATUS_INVITED: {
    ko: "초대됨",
    en: "Invited",
  },
  STUDY_MEMBER_STATUS_REGISTERED: {
    ko: "등록됨",
    en: "Registered",
  },
  STUDY_MEMBER_STATUS_LEFT: {
    ko: "ORG에서 삭제됨",
    en: "Deleted from the ORG",
  },
  MEMBERS_TAB: {
    ko: "Members",
    en: "Members",
  },
  ROLES_TAB: {
    ko: "Roles",
    en: "Roles",
  },

  MEMBER_NOUN: {
    ko: "Member",
    en: "Member",
  },
  ROLE_NOUN: {
    ko: "Role",
    en: "Role",
  },

  RESEND_VERB: {
    ko: "재발송",
    en: "Send a Email",
  },
  DELETE_VERB: {
    ko: "삭제",
    en: "Remove",
  },

  ADD_ROLE_VERB: {
    ko: "역할 추가",
    en: "Add Role",
  },
  INVITE_VERB: {
    ko: "초대",
    en: "Invite",
  },

  ROLE_DUPLICATE_DESCRIPTION: {
    ko: "동일한 이름의 Role이 존재합니다.",
    en: "Duplicate role name detected.",
  },

  CREATE_MEMBER_ROLE_SUCCEED: {
    ko: "역할 생성을 완료하였습니다.",
    en: "Role creation completed.",
  },
  CREATE_MEMBER_ROLE_FAIL: {
    ko: "역할 생성에 실패하였습니다.",
    en: "Role creation failed.",
  },
  MODIFY_MEMBER_ROLE_SUCCEED: {
    ko: "역할 변경을 완료했습니다.",
    en: "The role change has been completed.",
  },
  MODIFY_MEMBER_ROLE_FAIL: {
    ko: "역할 변경에 실패했습니다.",
    en: "Failed to change the role.",
  },
  STUDY_MEMBER_INVITATION_SUCCEED: {
    ko: "멤버 초대를 완료했습니다.",
    en: "The member invitation has been completed.",
  },
  STUDY_MEMBER_INVITATION_FAIL: {
    ko: "멤버 초대에 실패했습니다.",
    en: "Failed to invite members.",
  },
  STUDY_MEMBER_RESEND_EMAIL_SUCCEED: {
    ko: "초대 메일이 재발송 되었습니다.",
    en: "The invitation email has been resent.",
  },
  STUDY_MEMBER_RESEND_EMAIL_FAIL: {
    ko: "초대 메일 재발송에 실패했습니다.",
    en: "Failed to resend the invitation email.",
  },

  DELETION_MEMBER_SUCCEED: {
    ko: "맴버 삭제를 완료했습니다.",
    en: "The member has been deletion.",
  },
  DELETION_MEMBER_FAIL: {
    ko: "맴버 삭제에 실패했습니다.",
    en: "Failed to deletion the member.",
  },
  DELETION_MEMBER_ROLE_SUCCEED: {
    ko: "역할 삭제를 완료했습니다.",
    en: "The role has been deletion.",
  },
  DELETION_MEMBER_ROLE_FAIL: {
    ko: "역할 삭제에 실패했습니다.",
    en: "Failed to deletion the role.",
  },

  STUDY_ROLE_SWITCH_CONFIRM_TITLE: {
    ko: "탭 이동 확인",
    en: "Switch Tab Confirmation",
  },
  STUDY_ROLE_SWITCH_CONFIRM_DESCRIPTION: {
    ko: "현재 편집 중인 내용이 저장되지 않았습니다.\n탭 이동시 편집 내용은 복구되지 않습니다.\n\n다른 탭으로 이동하시겠습니까?",
    en: "The contents of the current editing are not stored.\nIf you move without storing it, the data in editing will be lost.\n\nWould you like to go to another tab?",
  },

  STUDY_MEMBER_ROLE_MODIFICATION_TITLE: {
    ko: "역할 변경",
    en: "Change Role",
  },
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_DELETION_DESCRIPTION: {
    ko: "삭제할 역할을 사용중인 멤버가 존재합니다.\n해당 멤버의 역할을 변경하여, 역할 삭제 작업을 계속 진행할 수 있습니다.",
    en: "There is a member currently using this role.\nYou can change the member’s role and then proceed to delete this role.",
  },
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_INACTIVE_DESCRIPTION: {
    ko: "역할을 사용중인 멤버가 존재합니다.\n해당 멤버의 역할을 변경하여, 역할 비활성화 작업을 계속 진행할 수 있습니다.",
    en: "A member is currently assigned to this role.\nPlease change the member’s role before disabling it.",
  },

  STUDY_MEMBER_TABLE_HEADER_NO: {
    ko: "No.",
    en: "No.",
  },
  STUDY_MEMBER_TABLE_HEADER_TYPE: {
    ko: "유형",
    en: "Type",
  },
  STUDY_MEMBER_TABLE_HEADER_NAME: {
    ko: "이름",
    en: "Name",
  },
  STUDY_MEMBER_TABLE_HEADER_EMAIL: {
    ko: "Email",
    en: "Email",
  },
  STUDY_MEMBER_TABLE_HEADER_ROLE: {
    ko: "역할",
    en: "Role",
  },
  STUDY_MEMBER_TABLE_HEADER_STATUS: {
    ko: "상태",
    en: "Status",
  },
  STUDY_MEMBER_TABLE_HEADER_LAST_SENT_EMAIL_DATE: {
    ko: "최근 메일 발송일",
    en: "Last Sent Email Date",
  },
  STUDY_MEMBER_TABLE_HEADER_ACTIVATED_AT: {
    ko: "시작 일시",
    en: "Activated At",
  },
  STUDY_MEMBER_INVITATION_DIALOG_TITLE: {
    ko: "멤버 초대",
    en: "Invite Member",
  },
  STUDY_MEMBER_INVITATION_DIALOG_EMAIL_PLACEHOLDER: {
    ko: "초대할 멤버 선택  또는 직접 입력",
    en: "Select or directly input members to invite",
  },
  STUDY_MEMBER_INVITATION_DIALOG_ROLE_PLACEHOLDER: {
    ko: "역할 선택",
    en: "Select a role.",
  },
};
//
MvnCodeInitiate(CONVERTER_STUDY_MEMBER_LANG);
